import React from 'react';
import { Eyebrow } from './Section';
interface PageHeaderProps {
  eyebrow: string;
  title: React.ReactNode;
  lede: string;
  children?: React.ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  lede,
  children
}: PageHeaderProps) {
  return <header className="paper-texture relative border-b border-line bg-paper" data-id="element-152" data-mp="3rduagnpjq98i">
      <div className="relative mx-auto w-full max-w-shell px-5 pb-14 pt-14 sm:px-8 sm:pb-16 sm:pt-20" data-id="element-153" data-mp="3mgu40bosb4gv">
        <div className="max-w-3xl" data-id="element-154" data-mp="2yqgb6iydl1l8">
          <Eyebrow data-id="element-155" data-mp="2tqvdebuxyza3">{eyebrow}</Eyebrow>
          <h1 className="mt-5 font-serif text-h1 text-charcoal" data-id="element-156" data-mp="2trwouhfvdnsc">{title}</h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-charcoal-600" data-id="element-157" data-mp="38fhtifse7v2d">{lede}</p>
          {children ? <div className="mt-8" data-id="element-158" data-mp="33ohvf77jf6ya">{children}</div> : null}
        </div>
      </div>
    </header>;
}